import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const StackTiny = styled.div.withConfig({ componentId: 'sc-1mb1kgs-0' })`
    & + & {
        margin-top: ${size(0.5)};
    }
`;

export const StackSmall = styled.div.withConfig({ componentId: 'sc-1mb1kgs-1' })`
    & + & {
        margin-top: ${size(1)};
    }
`;

export const Stack = styled.div.withConfig({ componentId: 'sc-1mb1kgs-2' })`
    & + & {
        margin-top: ${size(2)};
    }
`;

export const StackMedium = styled.div.withConfig({ componentId: 'sc-1mb1kgs-3' })`
    & + & {
        margin-top: ${size(3)};
    }
`;

export const StackLarge = styled.div.withConfig({ componentId: 'sc-1mb1kgs-4' })`
    & + & {
        margin-top: ${size(3)};

        ${(props) => props.theme.breakpoint.Md} {
            margin-top: ${size(4)};
        }
    }
`;
